export default __webpack_public_path__ + "static/media/europe.1cc6af31.jpg";